module.exports = __webpack_public_path__ + "img/Daluiski-bio.2d144113.jpg";